module.exports = __webpack_public_path__ + "static/img/alipay.06a2036.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/ts-img/alipay.png
// module id = G1RC
// module chunks = 1